import { LargeNumberLike } from "crypto";

type MultiSelectListProps = {
    allFormList: { label: string; value: number }[];
    listFilter: string;
    selectedItem: Set<string>;
    subOptions:[string, number, number,string][];
    setSelectedItem: React.Dispatch<React.SetStateAction<Set<string>>>;
    setListFilter: React.Dispatch<React.SetStateAction<string>>;
    titleWidth:number;
  };
  
export const MultiSelectList = ({
    allFormList,
    listFilter,
    selectedItem,
    subOptions,
    setSelectedItem,
    setListFilter,
    titleWidth,
  }: MultiSelectListProps) => {
  
    // Function to filter forms based on the listFilter value
    const SelectedForm = allFormList.filter(item => item.label.toLowerCase().includes(listFilter.toLowerCase()));
  
    // Function to handle checkbox state toggling
    const toggleCheckbox = (listId: number, itemId: number) => {
      const value = `${listId}${itemId}`;
      setSelectedItem(prev => {
        const newSet = new Set(prev);
        if (newSet.has(value)) {
          newSet.delete(value);
        } else {
          newSet.add(value);
        }
        return newSet;
      });
    };
  
    return (
      <div className="multi-select-list">
        <div className="multi-search-bar">
          <div className={`form-col${titleWidth}`}>
            <input
              className="isearch"
              type="text"
              placeholder="Search..."
              value={listFilter}
              onChange={(e) => setListFilter(e.target.value)}
            />
          </div>
          {subOptions.map(([title, value, width, tooltip], index) => {
            return (
              <div className={`form-col${width}`} key={index} title={tooltip}>{title}</div>
            );
          })}
        </div>
        <div className="multi-list-view">
          {SelectedForm.map(row => (
            <div key={row.value}>
              <div className={`form-col${titleWidth}`}>{row.label}</div>
              {subOptions.map(([title, value, width]) => {
                const joinRowItem = `${row.value}${value}`;
                return (
                  <div className={`form-col${width}`} key={joinRowItem}>
                    <label>
                      <input
                        type="checkbox"
                        title={title}
                        checked={selectedItem.has(joinRowItem)}
                        onChange={() => toggleCheckbox(row.value, value)}
                      />
                    </label>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    );
  };

  type SingleSelectListProps = {
    allFormList: { label: string; value: number }[];
    listFilter: string;
    selectedItem: Set<string>;
    setSelectedItem: React.Dispatch<React.SetStateAction<Set<string>>>;
    setListFilter: React.Dispatch<React.SetStateAction<string>>;
    titleWidth?:number;
    valueWidth?:number;
  };
  
export const SingleSelectList = ({
    allFormList,
    listFilter,
    selectedItem,
    setSelectedItem,
    setListFilter,
    titleWidth = 80,
    valueWidth = 20,
  }: SingleSelectListProps) => {
  
    // Function to filter forms based on the listFilter value
    const SelectedForm = allFormList.filter(item => item.label.toLowerCase().includes(listFilter.toLowerCase()));
  
    // Function to handle checkbox state toggling
    const toggleCheckbox = (listId: number) => {
      const value = `${listId}`;
      setSelectedItem(prev => {
        const newSet = new Set(prev);
        if (newSet.has(value)) {
          newSet.delete(value);
        } else {
          newSet.add(value);
        }
        return newSet;
      });
    };
  
    return (
      <div className="multi-select-list">
        <div className="multi-search-bar">
          <div className={`form-col${titleWidth}`}>
            <input
              className="isearch"
              type="text"
              placeholder="Search..."
              value={listFilter}
              onChange={(e) => setListFilter(e.target.value)}
            />
          </div>
          <div className={`form-col${valueWidth}`}>Select</div>
        </div>
        <div className="multi-list-view">
          {SelectedForm.map(row => (
            <div key={row.value}>
              <div className={`form-col${titleWidth}`}>{row.label}</div>
              <div className={`form-col${valueWidth}`}>
                <label>
                  <input
                    type="checkbox"
                    checked={selectedItem.has(row.value.toString())}
                    onChange={() => toggleCheckbox(row.value)}
                  />
                </label>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };